module.exports = __webpack_public_path__ + "static/media/MainLogo.27629987.svg";